export const CONTACT_CONFIG = {
	address: {
		title: 'North sea port gent',
		street: 'Doornzeelsestraat 58B',
		city: '9940 Evergem',
		country: 'Belgie',
	},
	info: {
		telephone: '+32 475/ 44 39 49',
		email: ' info@aertech.be',
	},
};



// WEBPACK FOOTER //
// ./src/components/molecules/contact/contact.config.js